import Card from "../../../../components/card";
import { DivH } from "../../../../components/divh/styled";
import IndicatorPercentValue from "../../../../components/indicator-percent-value";
import MoneySymbol from "../../../../components/money-symbol";
import PercentSymbol from "../../../../components/percent-symbol";
import { PeriodRefDto, PeriodValueDto } from "../../../../dto/home/period-value-response";

export interface Paran {
  value: PeriodValueDto;
  valueRef: PeriodRefDto;
}

const Hortifruit: React.FC<Paran> = ({value, valueRef}) => {
  return (
    <Card>
      <div style={{width: "100%", textAlign: "center"}}>Hortifruti</div>
      <DivH>
        <h4>{value.hortifruitLabelRef}</h4> 
        <h3><MoneySymbol value={value.hortifruitSaleRef}/></h3>
      </DivH>
      <DivH>
        <h4>Hortifruti </h4> 
        <h3><MoneySymbol value={value.hortifruitValueMt}/></h3>
      </DivH>
      <DivH>
        <h3> </h3> 
        <h4><PercentSymbol value={value.hortifruitPercentMt}/></h4>
      </DivH>

      <div style={{width: "100%", textAlign: "center"}}>{valueRef.label}</div>
      <DivH>
        <h4>{valueRef.hortifruitLabelRef}</h4> 
        <h3><MoneySymbol value={valueRef.hortifruitSaleRef}/></h3>
      </DivH>
            <DivH>
        <h4>Hortifruti </h4> 
        <h3><MoneySymbol value={valueRef.hortifruitValueMt}/></h3>
      </DivH>
      <DivH>
        <h3> </h3> 
        <h4><PercentSymbol value={valueRef.hortifruitPercentMt}/></h4>
      </DivH>

      <IndicatorPercentValue percent={value.hortifruitCrecimento} />

    </Card>
  )
};

export default Hortifruit;
// Quando filtrar o hortifutri, tem que mostrar quanto o hortifruti representa do total do varejo

// Dia 

// Venda Total Anterior - R$ x
// Venda Hortifruti Anterior  - R$ y
// Part Hort %

// Venda Total Atual - R$ x
// Venda Hortifruti Atual  - R$ y
// Part Atual %

// Cresc%